// extracted by mini-css-extract-plugin
module.exports = {"hoverMenu":"HoverMenu_hoverMenu__HYT_r"};